import apiClient from '../../../utilities/apiClient.js';

export const leaderShipDashboard = (payload) => {
  return apiClient.get(`${apiClient.Urls.leaderShipDashboard}`, payload, true);
};

export const leaderShipTableData = (payload) => {
  return apiClient.get(`${apiClient.Urls.leaderShipTableData}`, payload, true);
};

export const leaderShipToolAnalytics = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.leaderShipToolAnalytics}`,
    payload,
    true,
  );
};

export const leaderShipToolData = (payload) => {
  return apiClient.get(`${apiClient.Urls.leaderShipToolData}`, payload, true);
};

export const financialYears = (payload) => {
  return apiClient.get(`${apiClient.Urls.financialYears}`, payload, true);
};

export const quarterList = (payload) => {
  return apiClient.get(`${apiClient.Urls.quarterList}`, payload, true);
};

export const projectList = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.leadershipProjectList}`,
    payload,
    true,
  );
};

export const projectListWithoutQuarterly = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.leadershipProjectListWithoutQuarterly}`,
    payload,
    true,
  );
};

export const projectListManagerDashboard = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.leadershipProjectListManagerDashboard}`,
    payload,
    true,
  );
};

export const projectListWithoutQuarterlyManagerDashboard = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.leadershipProjectListWithoutQuarterlyManagerDashboard }`,
    payload,
    true,
  );
};

export const sbgList = (payload) => {
  return apiClient.get(`${apiClient.Urls.sbgList}`, payload, true);
};

export const sbuList = (payload) => {
  return apiClient.get(`${apiClient.Urls.sbuList}`, payload, true);
};

export const buList = (payload) => {
  return apiClient.get(`${apiClient.Urls.buList}`, payload, true);
};

// for tool adherence
export const projectList_TA = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.leadershipProjectList_TA}`,
    payload,
    true,
  );
};

export const sbgList_TA = (payload) => {
  return apiClient.get(`${apiClient.Urls.sbgList_TA}`, payload, true);
};

export const sbuList_TA = (payload) => {
  return apiClient.get(`${apiClient.Urls.sbuList_TA}`, payload, true);
};

export const buList_TA = (payload) => {
  return apiClient.get(`${apiClient.Urls.buList_TA}`, payload, true);
};
